import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface VideoRetakeConfirmationBottomSheetProps {
  modalState: UseModalState;
  onCancel: () => void;
  onContinue: () => void;
}

export function VideoRetakeConfirmationBottomSheet(props: VideoRetakeConfirmationBottomSheetProps) {
  const { modalState, onCancel, onContinue } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={onCancel}>
          <Button fullWidth variant="destructive" size="large" onClick={onContinue}>
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ px: 5, py: 6 }}>
        <Stack spacing={6} sx={{ paddingTop: 4 }}>
          <Title semibold variant="h3" component="h3" sx={{ textAlign: "center" }}>
            Are you sure?
          </Title>
          <Text variant="body1">
            You will delete the video you just recorded and need to record another.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
